// src/theme.ts atau theme.ts
import { createTheme } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import color from "tailwindcss/colors";

// Buat instance tema.
const AppTheme = createTheme({
  colorSchemes: { light: true, dark: false },
  palette: {
    mode: "light",
    primary: {
      main: "#5D9D53", // Contoh warna primer
    },
    secondary: {
      main: "#FFFFFF", // Contoh warna sekunder
    },
    error: {
      main: red.A400, // Contoh warna error dari palet warna MUI
    },
    background: {
      default: color.neutral[50], // Dark theme background
      paper: color.neutral[50], // Dark theme paper
    },
  },
  typography: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
    // Kustomisasi varian tipografi lainnya jika perlu
  },
  // Anda juga bisa mengkustomisasi komponen secara global di sini
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
        },
      },
    },
  },
});

export default AppTheme;
